import React from 'react';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import '../styles/site.css';
import './PublicLayout.css';

const PublicLayout = ({ children, title, subtitle }) => {
  return (
    <div className="arc-site public-layout">
      <SiteNav />
      {(title || subtitle) && (
        <header className="arc-page-hero">
          <div className="arc-container">
            {title && <h1>{title}</h1>}
            {subtitle && <p>{subtitle}</p>}
          </div>
        </header>
      )}
      <main className="public-main arc-container arc-fade-up arc-fade-up-d1">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
};

export default PublicLayout;
